"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutcodePostcodeLocationWrapper$ = exports.OutcodePostcodeLocationWrapper$outboundSchema = exports.OutcodePostcodeLocationWrapper$inboundSchema = void 0;
exports.outcodePostcodeLocationWrapperToJSON = outcodePostcodeLocationWrapperToJSON;
exports.outcodePostcodeLocationWrapperFromJSON = outcodePostcodeLocationWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const postcodelocationwrapper_js_1 = require("./postcodelocationwrapper.js");
/** @internal */
exports.OutcodePostcodeLocationWrapper$inboundSchema = z.object({
    attributes: z.array(postcodelocationwrapper_js_1.PostcodeLocationWrapper$inboundSchema),
    count: z.number().int(),
    id: z.string(),
    type: z.literal("outcode").default("outcode").optional(),
});
/** @internal */
exports.OutcodePostcodeLocationWrapper$outboundSchema = z.object({
    attributes: z.array(postcodelocationwrapper_js_1.PostcodeLocationWrapper$outboundSchema),
    count: z.number().int(),
    id: z.string(),
    type: z.literal("outcode").default("outcode"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var OutcodePostcodeLocationWrapper$;
(function (OutcodePostcodeLocationWrapper$) {
    /** @deprecated use `OutcodePostcodeLocationWrapper$inboundSchema` instead. */
    OutcodePostcodeLocationWrapper$.inboundSchema = exports.OutcodePostcodeLocationWrapper$inboundSchema;
    /** @deprecated use `OutcodePostcodeLocationWrapper$outboundSchema` instead. */
    OutcodePostcodeLocationWrapper$.outboundSchema = exports.OutcodePostcodeLocationWrapper$outboundSchema;
})(OutcodePostcodeLocationWrapper$ || (exports.OutcodePostcodeLocationWrapper$ = OutcodePostcodeLocationWrapper$ = {}));
function outcodePostcodeLocationWrapperToJSON(outcodePostcodeLocationWrapper) {
    return JSON.stringify(exports.OutcodePostcodeLocationWrapper$outboundSchema.parse(outcodePostcodeLocationWrapper));
}
function outcodePostcodeLocationWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.OutcodePostcodeLocationWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'OutcodePostcodeLocationWrapper' from JSON`);
}
//# sourceMappingURL=outcodepostcodelocationwrapper.js.map